import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Menu, MenuItem, Modal, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/Button/Button';
import Input from '../../../../../components/Input/Input';
import { IUpdateProjectFromFile } from '../../../../api/IApiRequest';
import * as BeMaccaferriStoreHelper from '../../../../api/store/BeMaccaferriStoreHelper';
import { projectToData as m1PtD } from '../../../../Macro1/store/project/projectslice';
import { projectToData as m2PtD } from '../../../../Macro2/store/project/projectslice';
import { endpoint } from '../../../../pages';
import { styles } from '../../../PDF/PDFStyle';
import { IOpenButtonProps } from './IOpenButton';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    padding: 5,
    width: 400,
};

var projectName: string;
var payload: IUpdateProjectFromFile;

const OpenButton = (props: IOpenButtonProps) => {
    const { t } = useTranslation();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [openModal, setOpenModal] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [processing, setProcessing] = React.useState(false);
    const inputFile = React.useRef<HTMLInputElement | null>(null);

    const open = Boolean(anchorEl);

    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleOpenCloud = async () => (window.location.href = endpoint.home);

    const handleOpenFile = async () => {
        inputFile.current?.click();
        setAnchorEl(null);
    };

    const handleChangeOpenLocalFile = (e: React.ChangeEvent<HTMLInputElement> | undefined) => {
        e!.preventDefault();
        const reader = new FileReader();
        reader.onload = async e => {
            const text = e.target!.result as string;
            const project = JSON.parse(text);
            payload = {
                ...project.projectInfo.data!,
                macro1Data: !project.macro1.project.initialState ? m1PtD(project.macro1.project.data) : null,
                macro2Data: !project.macro2.project.initialState ? m2PtD(project.macro2.project.data) : null,
            };
            projectName = payload.projectName;
            setOpenModal(true);
        };
        reader.readAsText(e!.target.files![0]);
    };

    const handleSave = async (event: any) => {
        setProcessing(true);
        event.preventDefault();
        if (projectName !== '') {
            payload.projectName = projectName;
            const res = await BeMaccaferriStoreHelper.updateProjectFromFileAsync(payload);
            setProcessing(false);
            setError(false);
            projectName = '';
            window.location.href = `/designCondition/${payload.projectType}/${res.data.projectId}`;
        } else {
            setError(true);
        }
        setProcessing(false);
    };

    return (
        <>
            <button type='button' className={props.className} onClick={handleOpenMenu}>
                <i className='fa-regular fa-folder-open' />
                {t('header_open_button')}
                <i className='fa-solid fa-angle-down' />
            </button>
            <Menu
                id='save-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                MenuListProps={{
                    'aria-labelledby': 'save-button',
                }}>
                <MenuItem onClick={handleOpenCloud}>{t('header_open_button_cloud')}</MenuItem>
                <MenuItem onClick={handleOpenFile}>{t('header_open_button_file')}</MenuItem>
            </Menu>
            <input hidden type='file' accept='.macro' ref={inputFile} onChange={handleChangeOpenLocalFile} onClick={e => ((e.target as any).value = '')} />
            <Modal open={openModal} onClose={() => setOpenModal(false)} aria-labelledby='modal-save-project' aria-describedby='modal-save-project-description'>
                <Box sx={style}>
                    <form>
                        <Stack height='100%' direction='column' spacing={4}>
                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                <Typography variant='h5' gutterBottom>
                                    {t('header_save_button_file')}
                                </Typography>
                                <IconButton aria-label='close-modal' onClick={() => setOpenModal(false)}>
                                    <CloseIcon />
                                </IconButton>
                            </Stack>
                            <Input
                                type='text'
                                required
                                defaultValue={projectName}
                                title={t('project_info_project_detail_project_name')}
                                name={'projectName'}
                                onChange={(e: any) => (projectName = e.target.value)}
                            />
                            {error && <span style={{ ...styles.red, marginTop: '10px' }}>{t('project_info_formik_required')}</span>}
                            <Stack direction={'row'} spacing={5} justifyContent={'space-around'}>
                                <Button disabled={processing} onClick={() => setOpenModal(false)}>
                                    {t('close_button')}
                                </Button>
                                <Button disabled={processing} onClick={handleSave}>
                                    {t('save_button')}
                                </Button>
                            </Stack>
                        </Stack>
                    </form>
                </Box>
            </Modal>
        </>
    );
};

export default OpenButton;
